const PROMOTION_BASE = "/jx/a/promotion";

const promotionPath = (path) => `${PROMOTION_BASE}${path}`;

const promotionIdPath = (path, id) => promotionPath(`${path}/${encodeURIComponent(id)}`);

const campusCertificationApplicationPath = (applicationId) =>
    `certifications/campus/applications/${encodeURIComponent(applicationId)}`;

const API = {
    coupons: { page: 'coupons/page', modules: 'coupons/modules', discountTypes: 'coupons/discount-types', checkoutCandidates: 'coupons/checkout-candidates' },
    serviceReviews: {
        accessUrl: (reviewId, imageId) => `photography/reviews/${encodeURIComponent(reviewId)}/images/${encodeURIComponent(imageId)}/access-url`,
        submit: no => `photography/service-orders/${encodeURIComponent(no)}/review`,
        list: (type, id) => `photography/providers/${encodeURIComponent(type)}/${encodeURIComponent(id)}/reviews`,
    },
    auth: {
        smsCode: "auth/register/smscode",
        loginSmsCode: "auth/login/smscode",
        resetPasswordSmsCode: "auth/resetpwd/smscode",
        register: "auth/register",
        login: "auth/login",
        refresh: "auth/refresh",
        logout: "auth/logout",
        resetPassword: "auth/resetpwd",
    },

    user: {
        info: "usercenter/userinfo",
        invitePoster: "usercenter/invite-poster",
        avatar: "usercenter/userhead",
        realname: "usercenter/realname",
        certification: "usercenter/certification",
        password: "usercenter/password",
        passwordSmsCode: "usercenter/password/smscode",
        photographer: "usercenter/photographer",
        goodsList: "usercenter/goodsList",
        goodsDetail: "usercenter/goodsDetail",
        deleteGoods: "usercenter/deleteGoods",
        dresser: "usercenter/dresser",
        worksStyle: "usercenter/worksstyle",
        certWorks: "usercenter/getcertworks",
        uploadCertWorks: "usercenter/uploadcertworks",
        leaseList: "usercenter/leaseList",
        leaseDetail: "usercenter/leaseDetail",
        deleteLease: "usercenter/deleteLease",
        uploadImage: "usercenter/uploadImage",
        addLease: "usercenter/addLease",
        editLease: "usercenter/editLease",
        withdraw: "usercenter/withdraw",
        realNameVerification: {
            status: "user/real-name/status",
            recognize: "user/real-name/recognize",
            confirm: "user/real-name/confirm",
        },
        realNameModification: {
            applications: "user/real-name/modification-applications",
            eligibility: "user/real-name/modification-applications/eligibility",
            withdrawApplication: (applicationId) => `user/real-name/modification-applications/${encodeURIComponent(applicationId)}/withdraw`,
        },
    },

    creatorCenter: {
        membership: "creator-center/membership",
        overview: "creator-center",
        join: "creator-center/join",
        smsCode: "creator-center/smscode",
        applicationAgreement: (professionalType) => `creator-center/application-agreements/${encodeURIComponent(professionalType)}`,
        photographer: {
            recovery: "creator-center/photographer/recovery",
            applications: "creator-center/photographer/applications",
            applicationList: "creator-center/photographer/applications",
            applicationDetail: (applicationId) => `creator-center/photographer/applications/${encodeURIComponent(applicationId)}`,
            styleOptions: "creator-center/photographer/style-options",
            currentMaterials: "creator-center/photographer/current-materials",
            currentStyles: "creator-center/photographer/current-styles",
            profile: "creator-center/photographer/profile",
            portraitSubmissionStatus: "creator-center/photographer/portrait-submission-status",
            styleMaterialUpdates: "creator-center/photographer/material-updates/styles",
            equipmentMaterialUpdates: "creator-center/photographer/material-updates/equipments",
            certificateMaterialUpdates: "creator-center/photographer/material-updates/certificates",
            deleteEquipment: (equipmentId) => `creator-center/photographer/equipments/${encodeURIComponent(equipmentId)}/delete`,
            deleteCertificate: (certificateId) => `creator-center/photographer/certificates/${encodeURIComponent(certificateId)}/delete`,
            withdrawMaterialUpdate: (applicationId) => `creator-center/photographer/material-updates/${encodeURIComponent(applicationId)}/withdraw`,
        },
        makeupArtist: {
            recovery: "creator-center/makeup-artist/recovery",
            applications: "creator-center/makeup-artist/applications",
            applicationList: "creator-center/makeup-artist/applications",
            applicationDetail: (applicationId) => `creator-center/makeup-artist/applications/${encodeURIComponent(applicationId)}`,
            currentMaterials: "creator-center/makeup-artist/current-materials",
            profile: "creator-center/makeup-artist/profile",
            portraitSubmissionStatus: "creator-center/makeup-artist/portrait-submission-status",
            certificateMaterialUpdates: "creator-center/makeup-artist/material-updates/certificates",
            deleteCertificate: (certificateId) => `creator-center/makeup-artist/certificates/${encodeURIComponent(certificateId)}/delete`,
            withdrawMaterialUpdate: (applicationId) => `creator-center/makeup-artist/material-updates/${encodeURIComponent(applicationId)}/withdraw`,
        },
    },

    certifications: {
        campus: {
            overview: "certifications/campus",
            qualification: "certifications/campus/qualification",
            reminderDismissal: "certifications/campus/reminder-dismissal",
            schools: "certifications/campus/schools",
            applications: "certifications/campus/applications",
            withdrawApplication: (applicationId) => `${campusCertificationApplicationPath(applicationId)}/withdraw`,
        },
    },

    photography: {
        catalog: "photography/catalog",
        themeDetail: (themeTypeId, themeId) => `photography/catalog/theme-types/${encodeURIComponent(themeTypeId)}/themes/${encodeURIComponent(themeId)}`,
        serviceItem: (serviceItemId) => `photography/catalog/service-items/${encodeURIComponent(serviceItemId)}`,
        venues: "photography/venues",
        quotes: "photography/quotes",
        quotePreview: "photography/quote-previews",
        professionalIdentityPrevalidation: "photography/professional-identities/prevalidate",
        appointments: "photography/appointments",
        paymentChannels: "photography/payment-channels",
        appointmentContactPhoneSmsCode: "photography/appointments/contact-phone/smscode",
        appointmentCoupons: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/coupons`,
        appointmentDetail: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}`,
        appointmentPaymentRequests: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/payment-requests`,
        appointmentPaymentSwitch: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/payment-requests/switch`,
        appointmentPaymentVerify: (appointmentNo, paymentRequestNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/payment-requests/${encodeURIComponent(paymentRequestNo)}/verify`,
        appointmentRefunds: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/refunds`,
        appointmentAssignmentTimeline: (appointmentNo, serviceOrderNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/service-orders/${encodeURIComponent(serviceOrderNo)}/assignment-timeline`,
        appointmentCancellationOverviewPreview: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/cancellations/appointment-preview`,
        cancelPhotographyAppointment: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/cancellations/appointment`,
        cancelUnpaidPhotographyAppointment: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/cancellations/unpaid`,
        appointmentCancellationPreview: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/cancellations/preview`,
        appointmentCancellations: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/cancellations`,
        appointmentCancellationResult: (appointmentNo, idempotencyKey) => `photography/appointments/${encodeURIComponent(appointmentNo)}/cancellations/${encodeURIComponent(idempotencyKey)}`,
        appointmentDispute: (disputeNo) => `photography/disputes/${encodeURIComponent(disputeNo)}`,
        creatorNoShow: (serviceOrderNo) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/creator-no-show`,
        creatorUserNoShow: (serviceOrderNo) => `photography/creator/service-orders/${encodeURIComponent(serviceOrderNo)}/user-no-show`,
        serviceOtherIssue: (serviceOrderNo) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/other`,
        serviceAfterSales: (serviceOrderNo) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/after-sales`,
        unselectedRefund: (serviceOrderNo) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/unselected-refund`,
        serviceAfterSalesOptions: (serviceOrderNo) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/after-sales-options`,
        disputeRefundRequest: (disputeNo) => `photography/disputes/${encodeURIComponent(disputeNo)}/refund-request`,
        withdrawDispute: (disputeNo) => `photography/disputes/${encodeURIComponent(disputeNo)}/withdraw`,
        disputeEvidence: (disputeNo) => `photography/disputes/${encodeURIComponent(disputeNo)}/evidence`,
        disputeStatements: (disputeNo) => `photography/disputes/${encodeURIComponent(disputeNo)}/statements`,
        completeDisputeEvidence: (disputeNo) => `photography/disputes/${encodeURIComponent(disputeNo)}/evidence-complete`,
        disputeEvidenceAccess: (disputeNo, evidenceId) => `photography/disputes/${encodeURIComponent(disputeNo)}/evidence/${encodeURIComponent(evidenceId)}/access-url`,
        userServiceCode: (serviceOrderNo) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/service-code`,
        userServiceContact: (serviceOrderNo) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/contact`,
        switchAppointmentPayment: (appointmentNo) => `photography/appointments/${encodeURIComponent(appointmentNo)}/payment-requests/switch`,
        photographerReadiness: "photography/creator-readiness/photographer",
        makeupReadiness: "photography/creator-readiness/makeup-artist",
        creatorInvitations: "photography/creator/invitations",
        creatorJobHall: (professionalType) => `photography/creator/job-hall/${encodeURIComponent(professionalType)}`,
        acceptCreatorJob: (serviceOrderNo) => `photography/creator/job-hall/${encodeURIComponent(serviceOrderNo)}/accept`,
        acceptCreatorInvitation: (serviceOrderNo) => `photography/creator/invitations/${encodeURIComponent(serviceOrderNo)}/accept`,
        rejectCreatorInvitation: (serviceOrderNo) => `photography/creator/invitations/${encodeURIComponent(serviceOrderNo)}/reject`,
        creatorSchedule: "photography/creator/job-hall/schedule",
        creatorServiceOrders: "photography/creator/service-orders",
        creatorServiceOrderDetail: (serviceOrderNo) => `photography/creator/service-orders/${encodeURIComponent(serviceOrderNo)}`,
        creatorFulfillment: (serviceOrderNo) => `photography/creator/service-orders/${encodeURIComponent(serviceOrderNo)}/fulfillment`,
        registerCreatorArrival: (serviceOrderNo) => `photography/creator/service-orders/${encodeURIComponent(serviceOrderNo)}/arrival`,
        creatorArrivalPhotoAccess: (serviceOrderNo, arrivalId) => `photography/creator/service-orders/${encodeURIComponent(serviceOrderNo)}/arrivals/${encodeURIComponent(arrivalId)}/photo-access`,
        checkInCreatorServiceOrder: (serviceOrderNo) => `photography/creator/service-orders/${encodeURIComponent(serviceOrderNo)}/check-in`,
        cancelCreatorServiceOrder: (serviceOrderNo) => `photography/creator/service-orders/${encodeURIComponent(serviceOrderNo)}/cancellations`,
        userRetouch: (serviceOrderNo) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/retouch`,
        sampleRetouch: (serviceOrderNo, creator = false) => `photography/${creator ? 'creator/' : ''}service-orders/${encodeURIComponent(serviceOrderNo)}/retouch`,
        samples: (serviceOrderNo, creator = false) => `${API.photography.sampleRetouch(serviceOrderNo, creator)}/samples`,
        selection: (serviceOrderNo) => `${API.photography.sampleRetouch(serviceOrderNo)}/selection`,
        extraPaymentRequests: (serviceOrderNo) => `${API.photography.sampleRetouch(serviceOrderNo)}/extra-payment-requests`,
        extraPaymentCurrent: (serviceOrderNo) => `${API.photography.extraPaymentRequests(serviceOrderNo)}/current`,
        extraPaymentRequest: (serviceOrderNo, paymentRequestNo) => `${API.photography.extraPaymentRequests(serviceOrderNo)}/${encodeURIComponent(paymentRequestNo)}`,
        extraPaymentVerify: (serviceOrderNo, paymentRequestNo) => `${API.photography.extraPaymentRequest(serviceOrderNo, paymentRequestNo)}/verify`,
        extraPaymentCancel: (serviceOrderNo, paymentRequestNo) => `${API.photography.extraPaymentRequest(serviceOrderNo, paymentRequestNo)}/cancel`,
        sampleAccess: (serviceOrderNo, creator = false) => `${API.photography.sampleRetouch(serviceOrderNo, creator)}/image-access`,
        sampleUploadTickets: (serviceOrderNo) => `${API.photography.sampleRetouch(serviceOrderNo, true)}/upload-tickets`,
        sampleUploadRenew: (serviceOrderNo, taskId) => `${API.photography.sampleUploadTickets(serviceOrderNo)}/${encodeURIComponent(taskId)}/renew`,
        sampleUploadComplete: (serviceOrderNo, taskId) => `${API.photography.sampleRetouch(serviceOrderNo, true)}/uploads/${encodeURIComponent(taskId)}/complete`,
        sampleUploadStatus: (serviceOrderNo, taskId) => `${API.photography.sampleRetouch(serviceOrderNo, true)}/uploads/${encodeURIComponent(taskId)}`,
        sampleUploadRetry: (serviceOrderNo, taskId) => `${API.photography.sampleUploadStatus(serviceOrderNo, taskId)}/retry`,
        versions: (serviceOrderNo, creator=false, versionNo=1) => `${API.photography.sampleRetouch(serviceOrderNo,creator)}/versions/${versionNo}`,
        confirm: (serviceOrderNo) => `${API.photography.sampleRetouch(serviceOrderNo)}/confirm`,
        feedback: (serviceOrderNo) => `${API.photography.sampleRetouch(serviceOrderNo)}/feedback`,
        retouchHistory: (serviceOrderNo, creator=false) => `${API.photography.sampleRetouch(serviceOrderNo,creator)}/history`,
        zipRequests: (serviceOrderNo) => `${API.photography.sampleRetouch(serviceOrderNo)}/zip-requests`,
        zipRequest: (serviceOrderNo, zipRequestNo) => `${API.photography.zipRequests(serviceOrderNo)}/${encodeURIComponent(zipRequestNo)}`,
        finalDownloadAccess: (serviceOrderNo, finalImageId) => `${API.photography.finals(serviceOrderNo)}/${encodeURIComponent(finalImageId)}/download-access`,
        finals: (serviceOrderNo) => `${API.photography.sampleRetouch(serviceOrderNo)}/finals`,
        versionSubmit: (serviceOrderNo, versionNo=1) => `${API.photography.versions(serviceOrderNo,true,versionNo)}/submit`,
        sampleSubmit: (serviceOrderNo) => `${API.photography.samples(serviceOrderNo, true)}/submit`,
        sampleUploadEvents: (serviceOrderNo) => `${API.photography.sampleRetouch(serviceOrderNo, true)}/upload-events`,
        userArrivalPhotoAccess: (serviceOrderNo, arrivalId) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/arrivals/${encodeURIComponent(arrivalId)}/photo-access`,
        userFulfillment: (serviceOrderNo) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/fulfillment`,
        finishUserServiceOrder: (serviceOrderNo) => `photography/service-orders/${encodeURIComponent(serviceOrderNo)}/finish`,
        requestCompletionReview: (serviceOrderNo) => `photography/creator/service-orders/${encodeURIComponent(serviceOrderNo)}/completion-review`,
        creatorRevenues: "photography/creator/revenues",
        creatorRevenueDetail: (serviceOrderNo) => `photography/creator/revenues/${encodeURIComponent(serviceOrderNo)}`,
        creatorDepositAccount: (professionalType) => `photography/creator-deposits/${encodeURIComponent(professionalType)}`,
        creatorDepositPaymentPreview: (professionalType) => `photography/creator-deposits/${encodeURIComponent(professionalType)}/payment-preview`,
        creatorDepositAgreementAcceptances: (professionalType) => `photography/creator-deposits/${encodeURIComponent(professionalType)}/agreement-acceptances`,
        creatorDepositPaymentChannels: (professionalType) => `photography/creator-deposits/${encodeURIComponent(professionalType)}/payment-channels`,
        creatorDepositPaymentRequests: (professionalType) => `photography/creator-deposits/${encodeURIComponent(professionalType)}/payment-requests`,
        creatorDepositPaymentSwitch: (professionalType) => `photography/creator-deposits/${encodeURIComponent(professionalType)}/payment-requests/switch`,
        creatorDepositPaymentCancel: (professionalType, paymentRequestNo) => `photography/creator-deposits/${encodeURIComponent(professionalType)}/payment-requests/${encodeURIComponent(paymentRequestNo)}/cancel`,
        creatorDepositPaymentVerify: (professionalType, paymentRequestNo) => `photography/creator-deposits/${encodeURIComponent(professionalType)}/payment-requests/${encodeURIComponent(paymentRequestNo)}/verify`,
        creatorDepositPayments: (professionalType) => `photography/creator-deposits/${encodeURIComponent(professionalType)}/payments`,
        creatorDepositFundDetails: (professionalType) => `photography/creator-deposits/${encodeURIComponent(professionalType)}/fund-details`,
    },

    order: {
        ownLeaseOrders: "usercenter/leaseorder",
        ownProductionOrders: "usercenter/makerorder",
        ownLeaseOrderStatus: "usercenter/leaseOrderStatus",
        ownProductionOrderStatus: "usercenter/makerOrderStatus",
        bookorderFilter: "usercenter/bookorderFilter",
        payWxpay: "pay/wxpay",
        leaseOrder: "lease/leaseorder",
        photographOrder: "photograph/bookorder",
        fieldOrder: "field/fieldorder",
        orderInfo: "photograph/orderinfo",
        downloadLink: "usercenter/downloadlink",
        leaseOrderDetail: "usercenter/leaseOrderDetail",
        photographOrderDetail: "usercenter/bookOrderDetail",
        fieldOrderDetail: "usercenter/fieldOrderDetail",
        sampleList: "usercenter/samplelist",
        uploadSample: "usercenter/uploadsample",
        sampleSelected: "usercenter/sampleselected",
        sampleStatus: "usercenter/samplestatus",
        deleteSample: "usercenter/deletesample",
        deleteChoice: "usercenter/deletechoice",
        choiceList: "usercenter/choicelist",
        uploadChoice: "usercenter/uploadchoice",
        choiceImage: "usercenter/choiceimage",
        choiceRemarks: "usercenter/choiceremarks",
    },

    original: {
        templetList: "usercenter/templetList",
        deleteTemplet: "usercenter/deleteTemplet",
        addTemplet: "usercenter/addTemplet",
        editTemplet: "usercenter/editTemplet",
        templetDetail: "usercenter/templetDetail",
    },

    goodsList: {
        leaseAmateur: "lease/leaseAmateur",
        leaseList: "lease/leaseList",
        fieldList: "field/fieldList",
        leaseCondition: "lease/leaseCondition",
        photograph: "photograph/photograph",
        lensmanExcellent: "lensman/lensmanExcellent",
        lensmanList: "lensman/lensmanList",
        lensmanCondition: "lensman/lensmanCondition",
        dresserExcellent: "dresser/dresserExcellent",
        dresserList: "dresser/dresserList",
        dresserCondition: "dresser/dresserCondition",
        fieldHandpick: "field/fieldHandpick",
        fieldCondition: "field/fieldCondition",
        videoList: "video/videoList",
        videoTypeList: "video/typeList",
    },

    goodsDetail: {
        leaseDetail: "lease/leaseDetail",
        photographDetail: "photograph/photographDetail",
        lensmanDetail: "lensman/lensmanDetail",
        shopGoodsList: "ushop/goodsList",
        shopGoodsDetail: "ushop/goodsDetail",
        dresserDetail: "dresser/dresserDetail",
        fieldDetail: "field/fieldDetail",
        videoDetail: "video/videoDetail",
    },

    banner: {
        main: "main/banner",
        photograph: "photograph/photographBanner",
        lensman: "lensman/lensmanBanner",
        dresser: "dresser/dresserBanner",
        field: "field/fieldBanner",
        fieldDetail: "field/fieldDetailBanner",
        lease: "lease/leaseBanner",
        video: "video/videoBanner",
        article: "content/article",
    },

    metope: {
        customdesigned: "GetTheHomePage/Customdesigned",
        listPage: "ListPage/ListPage",
        filters: "ListOfFilters/Filters",
        detailsPage: "DetailsPage/DetailsPage",
        customizationOrder: "CustomizationOrder/order",
        orderInformation: "OrderInformation/OrderInformation",
        submitOrder: "SubmitOrder/OrderInformation",
    },

    promotion: {
        schools: {
            list: promotionPath("/schools"),
            create: promotionPath("/schools"),
            disable: (schoolId) => promotionIdPath("/schools", schoolId) + "/disable",
        },
        buildings: {
            list: promotionPath("/buildings"),
            create: promotionPath("/buildings"),
            disable: (buildingId) => promotionIdPath("/buildings", buildingId) + "/disable",
        },
        appointments: {
            create: promotionPath("/appointments"),
            search: promotionPath("/appointments/search"),
            transfer: (appointmentId) => promotionIdPath("/appointments", appointmentId) + "/transfer",
            end: (appointmentId) => promotionIdPath("/appointments", appointmentId) + "/end",
            poster: (appointmentId) => promotionIdPath("/appointments", appointmentId) + "/poster",
        },
        summaries: promotionPath("/summaries"),
        invitations: {
            search: promotionPath("/invitations/search"),
            revoke: (invitationId) => promotionIdPath("/invitations", invitationId) + "/revoke",
            restore: (invitationId) => promotionIdPath("/invitations", invitationId) + "/restore",
        },
        posterTemplates: {
            list: promotionPath("/poster-templates"),
            create: promotionPath("/poster-templates"),
            enable: (templateId) => promotionIdPath("/poster-templates", templateId) + "/enable",
            disable: (templateId) => promotionIdPath("/poster-templates", templateId) + "/disable",
        },
    },
};

export default API;
